import React, { Component } from "react";
import { Link } from "react-router-dom";
// import { logger } from "../../../util/logger";
// import { get } from "../../../util/axiosLib";

// components
import Sidemenu from "../../../components/sidemenu";
import Header from "../../../components/dashHeader";
//import Load from "../../../assets/svg/other/loading2.svg";
import P2PMBuyTrades from "../../../components/p2pMBuyTrades"
import P2PMSellTrades from "../../../components/p2pMSellTrades"

//css
import "../../styles/dashboard/P2P.css";

export default class P2P extends Component {
  
  state = {
    sellSection: false,
  };

  async componentDidMount() {
    if( localStorage.getItem("expired") === "true" ) {
      const errmsg = document.getElementById("error-info2");
      errmsg.classList.add("err-auth-on");
      await this.setState({
        incorrectError: "Token expired, please login again.",
      });
      setTimeout(() => {
        window.location = "/";
      }, 2000);
    }
  }

  render() {
    const currentPage = "P2P";

    return (
      <div>
        <Sidemenu currentPage={currentPage} />
        <Header />
        <section className="p2p">
          <div className="p2p-container">
            <div className="p2p-content">
              <h1> P2P </h1>
                <div className="p2p-box">
                  {this.state.sellSection ? (
                    <div className="p2p-tabs">
                      <div
                        onClick={() => this.setState({ sellSection: false })}
                        className="p2p-sell-tab"
                      >
                        <p>
                          <span className="bold"> Buy </span>
                        </p>
                      </div>
                      <div
                        onClick={() => this.setState({ sellSection: true })}
                        className="p2p-buy-tab"
                      >
                        <p>
                          <span className="bold">Sell</span>
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="p2p-tabs">
                      <div
                        onClick={() => this.setState({ sellSection: false })}
                        className="p2p-buy-tab"
                      >
                        <p>
                          <span className="bold"> Buy </span>
                        </p>
                      </div>
                      <div
                        onClick={() => this.setState({ sellSection: true })}
                        className="p2p-sell-tab"
                      >
                        <p>Sell</p>
                      </div>
                    </div>
                  )}
                  {this.state.sellSection ? (
                    <div className="p2p-top-info">
                      {/* <p>N.B: All P2P trades are free</p> */}
                      <Link className="green bold" to="/dashboard/p2p"><p>Show All Listings</p></Link>
                      <Link to="/dashboard/p2psellad" className="red bold">
                        {" "}
                        Create Selling Ad{" "}
                      </Link>
                    </div>
                  ) : (
                    <div className="p2p-top-info">
                      {/* <p>N.B: All P2P trades are free</p> */}
                      <Link className="green bold" to="/dashboard/p2p"><p>Show All Listings</p></Link>
                      <Link to="/dashboard/p2pbuyad" className="green bold">
                        {" "}
                        Create Buying Ad{" "}
                      </Link>
                    </div>
                  )}
                  {this.state.sellSection ? (
                    <P2PMSellTrades />
                    
                  ) : (
                    <P2PMBuyTrades />
                    
                  )}
                </div>
                <div
                  id="error-info2"
                  className="err-auth zindex animate__animated animate__slideInDown">
                  <p><strong>{this.state.incorrectError}</strong></p>           
                </div>
        </div>
          </div>
        </section>
      </div>
    );
  }
}
